// Mock data for Recrutement Suisse website
import { careerArticles, recruitmentArticles } from './articles';

export const companyInfo = {
  name: "Recrutement Suisse",
  tagline: "Votre partenaire de confiance en recrutement",
  description: "Cabinet de recrutement spécialisé de premier plan, conseil RH et solutions d'externalisation en Suisse",
  logoIcon: "https://customer-assets.emergentagent.com/job_f1b6550b-0752-4661-b65a-a963f039fa33/artifacts/4l11afwi_2026-01-07%2012.01.48.png",
  logoText: "https://customer-assets.emergentagent.com/job_f1b6550b-0752-4661-b65a-a963f039fa33/artifacts/b2ansjqo_2026-01-07%2011.42.04.png"
};

export const navigation = {
  candidats: {
    title: "Candidats",
    items: [
      { label: "Rechercher un emploi", href: "/emplois" },
      { label: "Déposer votre CV", href: "/deposer-cv" },
      { label: "Conseils carrière", href: "/conseils-carriere" },
      { label: "Étude de rémunération", href: "/etude-remuneration" }
    ]
  },
  employeurs: {
    title: "Employeurs",
    items: [
      { label: "Nos solutions de recrutement", href: "/solutions" },
      { label: "Confier un recrutement", href: "/recrutement" },
      { label: "Conseils en recrutement", href: "/conseils-recrutement" },
      { label: "Étude de rémunération", href: "/etude-remuneration" }
    ]
  },
  services: {
    title: "Nos services",
    items: [
      { label: "Recrutement permanent", href: "/services/recrutement-permanent" },
      { label: "Management de transition", href: "/services/management-transition" },
      { label: "RPO", href: "/services/rpo" },
      { label: "Market Intelligence", href: "/services/market-intelligence" }
    ]
  },
  about: {
    title: "À propos",
    items: [
      { label: "Notre histoire", href: "/a-propos" },
      { label: "Nos équipes", href: "/equipes" },
      { label: "Nos bureaux", href: "/bureaux" },
      { label: "Carrières chez nous", href: "/carrieres" }
    ]
  }
};

export const heroContent = {
  title: "Expert en recrutement spécialisé, conseil RH et solutions d'externalisation en Suisse",
  subtitle: "Concentrons-nous sur votre réussite professionnelle",
  description: "Nous consacrons du temps à créer des relations durables avec nos candidats et nos partenaires. C'est pourquoi nous sommes le partenaire privilégié pour vos recrutements.",
  ctaEmployer: "Recrutez avec nous",
  ctaCandidat: "Déposez votre CV",
  heroImage: "https://images.unsplash.com/photo-1573164574511-73c773193279?w=1600&q=80"
};

export const locations = [
  { value: "", label: "Localisation" },
  { value: "zurich", label: "Canton de Zurich" },
  { value: "geneve", label: "Canton de Genève" },
  { value: "vaud", label: "Canton de Vaud" },
  { value: "berne", label: "Canton de Berne" },
  { value: "basel", label: "Cantons de Bâle et Argovie" },
  { value: "lucerne", label: "Cantons de Zoug et Lucerne" },
  { value: "neuchatel", label: "Cantons de Neuchâtel et Berne" },
  { value: "autres", label: "Autres" }
];

export const solutions = [
  {
    id: 1,
    title: "Recrutement Permanent",
    description: "Profitez de notre savoir-faire sectoriel pointu, notre présence locale et notre réseau mondial pour mettre en avant votre entreprise et attirer les talents qui feront évoluer votre organisation.",
    image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=800&q=80",
    link: "/services/recrutement-permanent"
  },
  {
    id: 2,
    title: "RPO - Externalisation",
    description: "Découvrez nos solutions flexibles d'externalisation du processus de recrutement, personnalisées selon vos besoins, évolutives et conçues pour atteindre vos objectifs stratégiques.",
    image: "https://images.unsplash.com/photo-1664464683525-29b5d442af54?w=800&q=80",
    link: "/services/rpo"
  },
  {
    id: 3,
    title: "Market Intelligence",
    description: "Optimisez vos stratégies de recrutement avec nos analyses de marché basées sur les données. Offrez à votre entreprise les ressources nécessaires pour développer ses talents et assurer sa croissance.",
    image: "https://images.unsplash.com/photo-1758518730384-be3d205838e8?w=800&q=80",
    link: "/services/market-intelligence"
  }
];

export const salaryStudy = {
  title: "Étude de rémunération 2026",
  description: "Découvrez les tendances salariales et de recrutement dans votre secteur d'activité",
  ctaCandidat: "Comparez votre salaire",
  ctaEmployeur: "Comparez les salaires de vos équipes",
  image: "https://images.unsplash.com/photo-1573649647330-b3a1375227fe?w=1600&q=80"
};

export const expertises = [
  { id: 1, title: "Comptabilité & Finance", href: "/expertise/finance" },
  { id: 2, title: "Technologie & Digital", href: "/expertise/technology" },
  { id: 3, title: "Services Financiers", href: "/expertise/services-financiers" },
  { id: 4, title: "Juridique & Conformité", href: "/expertise/juridique" },
  { id: 5, title: "Management de Transition", href: "/expertise/interim" }
];

export const expertiseImage = "https://images.unsplash.com/photo-1617021093300-8ef857a4d2d5?w=800&q=80";

export const hiringAdvice = recruitmentArticles.slice(0, 2).map(article => ({
  ...article,
  link: `/conseils-recrutement/${article.slug}`,
}));

export const careerAdvice = careerArticles.slice(0, 4).map(article => ({
  ...article,
  link: `/conseils-carriere/${article.slug}`,
}));

export const testimonials = [
  {
    id: 1,
    name: "Sophie Müller",
    role: "Directrice RH",
    company: "Groupe Chocolatiers SA",
    story: "En tant que directrice des ressources humaines d'un groupe chocolatier basé en Suisse, Sophie collaborait déjà avec Recrutement Suisse depuis plusieurs années. Lorsque son entreprise a décidé d'étendre ses opérations, elle n'a pas hésité à faire appel à nos services pour recruter les meilleurs talents.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80",
    link: "/a-propos"
  },
  {
    id: 2,
    name: "Thomas Weber",
    role: "CTO",
    company: "FinTech Solutions AG",
    story: "Après une restructuration chez son précédent employeur, une banque digitale où Thomas occupait le poste de CTO pendant plus de trois ans, il a décidé de se lancer dans une nouvelle aventure. Grâce à Recrutement Suisse, Thomas a trouvé le poste idéal dans une startup innovante.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80",
    link: "/a-propos"
  },
  {
    id: 3,
    name: "Marie Dubois",
    role: "Consultante Senior",
    company: "Recrutement Suisse",
    story: "Sa passion pour les relations humaines et son expertise en recrutement ont inspiré Marie tout au long de sa carrière. Après avoir travaillé dans différents secteurs, elle a rejoint Recrutement Suisse pour accompagner candidats et entreprises dans leurs projets.",
    image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=400&q=80",
    link: "/a-propos"
  }
];

export const footerLinks = {
  candidats: {
    title: "Candidats",
    links: [
      { label: "Rechercher un emploi", href: "/emplois" },
      { label: "Déposer votre CV", href: "/deposer-cv" },
      { label: "Conseils carrière", href: "/conseils-carriere" },
      { label: "Étude de rémunération", href: "/etude-remuneration" }
    ]
  },
  employeurs: {
    title: "Employeurs",
    links: [
      { label: "Confier un recrutement", href: "/recrutement" },
      { label: "Nos solutions", href: "/solutions" },
      { label: "Conseils en recrutement", href: "/conseils-recrutement" },
      { label: "Étude de rémunération", href: "/etude-remuneration" }
    ]
  },
  services: {
    title: "Nos services",
    links: [
      { label: "Recrutement permanent", href: "/services/recrutement-permanent" },
      { label: "Management de transition", href: "/services/management-transition" },
      { label: "RPO", href: "/services/rpo" },
      { label: "Market Intelligence", href: "/services/market-intelligence" }
    ]
  },
  about: {
    title: "À propos",
    links: [
      { label: "Notre histoire", href: "/a-propos" },
      { label: "Nos équipes", href: "/equipes" },
      { label: "Nos bureaux", href: "/bureaux" },
      { label: "Nous rejoindre", href: "/carrieres" }
    ]
  }
};

export const contactInfo = {
  offices: [
    { city: "Zurich", address: "Limmatquai 112, 8001 Zürich", phone: "+41 44 250 88 88" },
    { city: "Genève", address: "Rue du Rhône 118, 1204 Genève", phone: "+41 22 318 88 88" },
    { city: "Lausanne", address: "Place de la Gare 4, 1003 Lausanne", phone: "+41 21 341 88 88" }
  ],
  social: [
    { name: "LinkedIn" },
    { name: "Twitter" },
    { name: "Facebook" },
    { name: "Instagram" }
  ]
};
